import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App.tsx';
import { auth } from '@/lib/firebase.ts';
import { Toaster } from '@/components/ui/sonner';
import { ErrorBoundary } from '@/components/error-boundary';

async function initializeClaims() {
  const user = auth.currentUser;
  if (user) {
    // Force a refresh so newly-granted custom claims are reflected immediately,
    // instead of waiting for the cached token to expire (~1h) or a manual
    // re-login. Without this, a stale token shows the user only the homepage.
    const idTokenResult = await user.getIdTokenResult(true);
    return {
      tvController: !!idTokenResult.claims.tvController || false,
      channelGuide: !!idTokenResult.claims.channelGuide || false,
      boxes: !!idTokenResult.claims.boxes || false,
      admin: !!idTokenResult.claims.admin || false,
    };
  }
  return {
    tvController: false,
    channelGuide: false,
    boxes: false,
    admin: false,
  };
}

async function initializeApp() {
  await auth.authStateReady();
  const claims = await initializeClaims();
  createRoot(document.getElementById('root')!, {
    // Log the component stack for any render crash — with sourcemaps enabled
    // this names the failing component instead of a minified frame.
    onUncaughtError: (error, errorInfo) => {
      console.error('Uncaught render error:', error, errorInfo.componentStack);
    },
    onCaughtError: (error, errorInfo) => {
      console.error('Render error (caught):', error, errorInfo.componentStack);
    },
  }).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App {...claims} />
      </ErrorBoundary>
      <Toaster />
    </React.StrictMode>
  );
}

initializeApp();
